import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'labeled-field-hospital',
  templateUrl: './labeled-field-hospital.component.html',
  styleUrls: ['./labeled-field-hospital.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabeledFieldHospitalComponent {
  @Input() label: string;
  @Input() help: string;
  @Input() required: boolean = false;
  @Input() actionText: string;
  @HostBinding('class') @Input() labelDirection: 'row' | 'column' = 'column';
  @Output() action = new EventEmitter();
}
